module.exports = __webpack_public_path__ + "media/cardinal_sin.99630428.wav";